import { cn } from "../../lib/utils.ts";
import type { FC, ReactNode } from "react";

export type BadgeState = "default" | "success" | "error" | "warning";

export type BadgeProps = {
  children: ReactNode;
  state?: BadgeState;
  className?: string;
};

const getDesignWithState = (state?: BadgeState): string => {
  if (state === "default") return "bg-[#F7F8F9] text-[#44546F] text-semibold";

  if (state === "success") return "bg-[#DCFFF1] text-[#216E4E] text-semibold";
  if (state === "error") return "bg-[#FFF1F1] text-[#750E13] text-semibold";
  if (state === "warning") return "bg-[#FFF3EB] text-[#702E00] text-semibold";

  return "bg-[#F7F8F9] text-[#44546F] font-semibold";
};

const Badge: FC<BadgeProps> = ({ state, children, className }) => {
  return (
    <div
      className={cn(
        getDesignWithState(state),
        "whitespace-nowrap w-[min-content] flex items-center px-[8px] py-[4px] rounded-[40px] gap-[5px]",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Badge;
